import React from 'react';
import { Table, Icon } from 'antd';
import TablePageSize from './TablePageSize';

const placeholder = <Icon type="loading" style={{ fontSize: 44 }} spin />;

const ExecutorsTable = props => {
  const {
    executors,
    pages,
    onChangeTable,
    changePaginationSize,
    renderColumns,
    tableColumnsLen,
    isLoading,
    handleClickRow,
    // onChangeRowSelection,
    // selectedRowKeys,
  } = props;
  /*
  const rowSelection = {
    selectedRowKeys,
    onChange: selectedRowKeys => {
      onChangeRowSelection(selectedRowKeys);
    },
  };*/
  return (
    <div className="executors__table">
      <Table
        locale={{
          emptyText: isLoading ? placeholder : 'Исполнителей нет',
        }}
        columns={renderColumns()}
        dataSource={executors}
        rowKey="id"
        pagination={{ pageSize: pages }}
        onRow={handleClickRow}
        onChange={onChangeTable}
        // rowSelection={rowSelection}
        scroll={tableColumnsLen > 8 ? { x: '140%' } : { x: false }}
      />
      {executors.length > 0 ? (
        <TablePageSize pages={pages} onChange={changePaginationSize} />
      ) : null}
    </div>
  );
};

export default ExecutorsTable;
